import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";

function TeacherBanner() {
  const { t } = useTranslation();
  let location = useLocation();
  //console.log("asd", location?.state);
  return (
    <section className="teacherBanner">
      <div className="inner-wrapper animate-from-bottom">
        <div className="teacher-title">
          <h1>{t("teacherIntro.IntroTitle")}</h1>

          <div className="sub-title">{t("teacherIntro.IntroDesc1")}</div>

          <div className="cta-btn center">
            <Link
              to={{
                pathname: "/register",
                state: "teacher",
                comeFrom: location?.state?.comeFrom === "/teachers" ? true : false,
              }}
            >
              {t("Be an Instructor")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TeacherBanner;
